import pImg1 from '../images/portfolio/portfolio_item_image_1.jpg'
import pImg2 from '../images/portfolio/portfolio_item_image_2.jpg'
import pImg3 from '../images/portfolio/portfolio_item_image_3.webp'
import pImg4 from '../images/portfolio/portfolio_item_image_4.webp'
import pImg5 from '../images/portfolio/portfolio_item_image_5.webp'
import pImg6 from '../images/case/case_image_3.webp'

import pImg7 from '../images/portfolio/portfolio_item_image_4.webp'
import pImg8 from '../images/portfolio/portfolio_item_image_5.webp'
import pImg9 from '../images/portfolio/portfolio_item_image_6.webp'
import pImg10 from '../images/portfolio/portfolio_item_image_7.webp'
import pImg11 from '../images/portfolio/portfolio_item_image_8.webp'
import pImg12 from '../images/portfolio/portfolio_item_image_9.webp'
import pImg13 from '../images/portfolio/portfolio_item_image_10.webp'
import pImg14 from '../images/portfolio/portfolio_item_image_11.webp'


import tImg1 from '../images/case/icon_angular.svg'
import tImg2 from '../images/case/icon_elephent.svg'
import tImg3 from '../images/case/icon_netcore.svg'
import tImg4 from '../images/case/vuejs.svg'
import tImg5 from '../images/case/icon_python.svg'


const Project = [
	{
        Id: '1',
        pImg: pImg1,
        title: 'The Destiny',
        slug: 'the-destiny',
        sub: 'Photo Shoot',
        description: '',
		category: 'photography',
    },
    {
        Id: '2',
        pImg: pImg2,
        title: 'New Bharat',
        slug: 'new-bharat',
        sub: 'Product Video',
        description: '',
		category: 'productvideo', 
    },
    {
        Id: '3',
        pImg: pImg4,
        title: 'Oneten',
        slug: 'oneten',
        sub: 'Photo Shoot',
        description: '',
		category: 'corporatefilm',
    },
    {
        Id: '4',
        pImg: pImg5,
        title: 'Goware',
        slug: 'goware',
        sub: 'Photo Shoot & Videos',
        description: '',
		category: 'brandvideo',
    },
    {
        Id: '5',
        pImg: pImg3,
        title: '99.5p',
        slug: 'ninety-nine-point-five-p',
        sub: 'Photo Shoot & Videos',
        description: '',
		category: 'productvideo',
    },
	
]

export default Project;